var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C14.7579 12 17 9.53368 17 6.5C17 3.46632 14.7579 1 12 1C9.24211 1 7 3.46632 7 6.5C7 9.53368 9.24211 12 12 12ZM12 2.73684C13.8842 2.73684 15.4211 4.42737 15.4211 6.5C15.4211 8.57263 13.8842 10.2632 12 10.2632C10.1158 10.2632 8.57895 8.57263 8.57895 6.5C8.57895 4.42737 10.1158 2.73684 12 2.73684Z",
    fill: "#303030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1183 21.2353H5.1087C4.3287 21.2353 3.69565 20.5765 3.69565 19.7647C3.69565 17.0118 5.85478 14.7647 8.5 14.7647H14.1522C14.6157 14.7647 15 14.3647 15 13.8824C15 13.4 14.6157 13 14.1522 13H8.5C4.91652 13 2 16.0353 2 19.7647C2 21.5529 3.39043 23 5.1087 23H14.1183C14.5817 23 14.9661 22.6 14.9661 22.1176C14.9661 21.6353 14.5817 21.2353 14.1183 21.2353Z",
    fill: "#303030"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1 17.2H19.4V14.8C19.4 14.3627 18.992 14 18.5 14C18.008 14 17.6 14.3627 17.6 14.8V17.2H14.9C14.408 17.2 14 17.5627 14 18C14 18.4373 14.408 18.8 14.9 18.8H17.6V21.2C17.6 21.6373 18.008 22 18.5 22C18.992 22 19.4 21.6373 19.4 21.2V18.8H22.1C22.592 18.8 23 18.4373 23 18C23 17.5627 22.592 17.2 22.1 17.2Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRequest);
export default __webpack_public_path__ + "static/media/user-request.207adce7656305841aa5d1191b6eeeed.svg";
export { ForwardRef as ReactComponent };